import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import { gsap } from 'gsap';
import { md, lg, xl, wide, xwide } from '../common';
import { bindElementSizeProperties } from '../lib/bindElementSizeProperties';

export function initBlockCards(parent) {
  if (!parent) return;

  const swiperEl = parent.querySelector(
    '.block-cards__swiper, .block-cards__carousel',
  );
  if (swiperEl) {
    const pagination = swiperEl.querySelector('.swiper-pagination');
    new Swiper(swiperEl, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        [md]: { slidesPerView: 2, spaceBetween: 20 },
        [lg]: { slidesPerView: 3, spaceBetween: 20 },
        [wide]: { slidesPerView: 3, spaceBetween: 24 },
        [xwide]: { slidesPerView: 3, spaceBetween: 32 },
      },
    });
  }

  const sliderBlocks = parent.querySelectorAll('.block-cards__slider');
  sliderBlocks.forEach((swiperEl) => {
    const pagination = swiperEl.querySelector('.swiper-pagination');
    const prevEl = swiperEl.querySelector('.swiper-button-prev');
    const nextEl = swiperEl.querySelector('.swiper-button-next');
    new Swiper(swiperEl, {
      modules: [Navigation, EffectFade, Pagination],
      effect: 'fade',
      speed: 500,
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: {
        prevEl,
        nextEl,
      },
    });
  });

  const scrollerBlocks = [
    ...parent.querySelectorAll('.block-cards__scroll-item'),
  ];
  scrollerBlocks.forEach((block, idx) => {
    const prevBlock = scrollerBlocks?.[idx - 1];
    const prevCard = prevBlock?.querySelector('*:first-child');
    bindElementSizeProperties(block);

    if (prevBlock) {
      gsap.set(prevCard, { opacity: 1 });
      gsap.to(prevCard, {
        scrollTrigger: {
          trigger: block,
          start: 'top top+=50%',
          //end: 'bottom top+=10%',
          // markers: true,
          scrub: true,
        },

        opacity: 0,
      });
    }
  });

  const cards = parent.querySelectorAll('.block-cards__item');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initAllBlockCards() {
  const blocks = document.querySelectorAll('.js-block-cards');
  blocks.forEach((block) => initBlockCards(block));
}
